// extracted by mini-css-extract-plugin
export default {"datacardTexts":"pinCodeCardStyles_datacardTexts__CWuy0"};